import React, { useEffect, useState } from 'react';
import './PriceGuideToaster.css';

const PriceGuideToaster: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hasSeenToaster = sessionStorage.getItem('seenPriceGuide');
    if (!hasSeenToaster) {
      setTimeout(() => {
        setVisible(true);
        sessionStorage.setItem('seenPriceGuide', 'true');
      }, 2000);
    }
  }, []);

  if (!visible) return null;

  


  return (
    <div className="price-guide-toaster">
      <div className="toaster-content">
        <div>
          <h4>✨ Price Guide Available</h4>
          <p>
            See what we offer and how much it costs.
            <br />
            <a href="/price-guide" className="toaster-link">
              View full price guide →
            </a>
          </p>
        </div>
        <button className="toaster-close" onClick={() => setVisible(false)} aria-label="Close">
          ×
        </button>
      </div>
    </div>
  );
};

export default PriceGuideToaster;
